/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LogService, ModalService } from '../../../../../core/services';
import { TimerService } from '../../services/utilities';

@Component({
    selector: 'app-count-down',
    templateUrl: './count-down-wait.component.html',
    styleUrls: ['./count-down-wait.component.scss']
})
export class CountDownWaitComponent {
    /**
     * Title for the modal
     */
    @Input() public title: string = '';

    /**
     * Description for the modal
     */
    @Input() public description: string = '';

    /**
     * Count down start from
     */
    @Input() public from: number = 10;

    /**
     * Interval between counts (milliseconds)
     */
    @Input() public interval: number = 1000;

    /**
     * Force close button to show.
     */
    @Input() public showCloseButton: boolean = false;

    /**
     * Show either the countdown numbers or just a loading spinner.
     */
    @Input() public waitOption: 'countdown' | 'loadingSpinner' = 'countdown';

    /**
     * Send intervals to the parent component
     */
    @Output() public intervalOut: EventEmitter<any> = new EventEmitter();

    /**
     * Output for when the count is complete
     */
    @Output() public takeOff: EventEmitter<any> = new EventEmitter();

    /**
     * Stored count down text to be displayed in the view.
     */
    public countDownText: string = '';

    constructor(
        public modal: ModalService,
        private logService: LogService,
        private timerService: TimerService,
    ) {
    }

    /**
     * Starts the count-down to reload
     */
    public start() {
        this.logService.info('CountDownWaitComponent: start', 'Count down started');
        this.modal.openModalInParent('countDownModal');
        this.timerService.addInterval('countDownModal', () => this.updateCountDown(), 1);
    }

    /**
     * Option to finish countdown early
     */
    public finish() {
        this.logService.info('CountDownWaitComponent: finish', 'Count down finished');
        this.timerService.removeInterval('countDownModal');
        this.modal.close('countDownModal');
        this.takeOff.next(true);
    }

    /**
     * Displays the count-down and reload on 0
     */
    private updateCountDown() {
        this.logService.info('CountDownWaitComponent: updateCountDown', 'Counter running');
        this.from--;
        if (this.from === 0) {
            this.modal.close('countDownModal');
            this.takeOff.next(true);

        }
        this.countDownText = this.from.toString(10);
        this.intervalOut.next(this.from);
    }
}
